import { EXPIRY_TIME_IN_SECONDS } from "../config/Constants";
import {
  CommonContent,
  CommonContentType,
  ContentKey,
  TranslatableImagesTypes,
  ButtonTypes,
  CardQuestion,
} from "../types/Types";
import Api from "./DrupalApi";
import { getSelectedLanguage } from "./Language";
import Localforage from "./Localforage";
const CONTENT_KEY = "commonContent";

const getContent = async (refresh?: boolean): Promise<CommonContent[]> => {
  const content = await Localforage.getItemWithExpiry<CommonContent[]>(
    CONTENT_KEY
  );
  if (content && !refresh) {
    return content;
  }
  const { data } = await Api.getCommonContent(getSelectedLanguage());
  await Localforage.saveItemWithExpiry(CONTENT_KEY, data, EXPIRY_TIME_IN_SECONDS);
  return data;
};

const filterByCommonContentType = (
  contents: CommonContent[],
  type: CommonContentType
): CommonContent[] => contents.filter((content) => content.type === type);

const getAllCardsQuestions = (
  contents: CommonContent[],
  type: CommonContentType
): CardQuestion[] =>
  filterByCommonContentType(contents, type).map((item) => ({
    id: item.id,
    label: item.name,
  }));

const getCardQuestions = (cardQuestions: CardQuestion[], cardIds: string[]) =>
  cardQuestions.filter((item) => cardIds.some((value) => value === item.id));

const isRightAnswer = (answers: CardQuestion[], answerId: string) =>
  answers.some((item) => item.id === answerId);

const getButtonName = (
  contents: CommonContent[],
  buttonLabel: ButtonTypes
): string =>
  contents.find((content) => content.buttonLabel === buttonLabel)?.name ||
  buttonLabel;

const getNameById = (contents: CommonContent[], id: string): string =>
  contents.find((content) => content.id === id)?.name || id;

const filterByContentKey = (
  contents: CommonContent[],
  contentKey: ContentKey
): CommonContent | undefined =>
  contents.find((content) => content.contentKey === contentKey);

const filterByImageKey = (
  contents: CommonContent[],
  imageKey: TranslatableImagesTypes
): CommonContent | undefined =>
  contents.find((content) => content.imageKey === imageKey);

const getKeyValue = (
  content: CommonContent[] | undefined,
  contentKey: ContentKey
): string => {
  return content
    ? filterByContentKey(content, contentKey)?.name || contentKey
    : contentKey;
};

export default {
  filterByCommonContentType,
  getButtonName,
  filterByContentKey,
  filterByImageKey,
  getContent,
  getKeyValue,
  getNameById,
  getCardQuestions,
  getAllCardsQuestions,
  isRightAnswer,
};
